export default "__VITE_ASSET__CODThwhI__"